import React, { useState, useRef, useEffect } from 'react';
import DashboardHeader from "./DashboardHeader";
import location from "../../assets/svg/location_icon.svg"
import total_invoice from "../../assets/svg/total_sales_invoice_icon.svg"
import final_invoice from "../../assets/svg/final_sales_invoice_icon.svg"
import contract_overview_icon from "../../assets/svg/contract_overview_icon.svg"
import daterange from "../../assets/svg/daterange_icon.svg"
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import DatePicker from "react-datepicker";
import AsyncSelect from "react-select/async";
import { ToastContainer, toast } from "react-toastify";
import axiosInstance from '../../axiosInstance';
import "react-datepicker/dist/react-datepicker.css";
import "../../styles/Dashboard.css";
import { FaStar } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { Bar } from "react-chartjs-2";
import { components } from 'react-select';
import { Pie } from "react-chartjs-2";
import ApexCharts from "apexcharts";
import { Chart, Chart as ChartJS, CategoryScale, LinearScale, ArcElement, BarElement, Tooltip, Legend, PieController } from "chart.js";
import LiquidChart from './LiquidChart';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { usePermissions } from "../../hooks/PermissionContext";
import PermissionWrapper from "../../hooks/PermissionWrapper";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";
ChartJS.register(CategoryScale, ArcElement, LinearScale, BarElement, Tooltip, Legend, PieController);

const Dashboard = () => {

  const rating = 3;
  let ModuleId = 29;
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [activeTab, setActiveTab] = useState("Operational");
  const [jobsDateRange, setJobsDateRange] = useState([null, null]);
  const [salesDateRange, setSalesDateRange] = useState([null, null]);
  const [costDateRange, setCostDateRange] = useState([null, null]);
  const [contractsData, setContractsData] = useState(null);
  const [jobsData, setJobsData] = useState(null);
  const [salesInvoiceData, setSalesInvoiceData] = useState(null);
  const [costInvoiceData, setCostInvoiceData] = useState(null);
  const [projectsData, setProjectsData] = useState(null);
  const [jobsStartDate, jobsEndDate] = jobsDateRange;
  const [salesStartDate, salesEndDate] = salesDateRange;
  const [costStartDate, costEndDate] = costDateRange;
  const [billingDateRange, setBillingDateRange] = useState([null, null]);
  const [accrualOverviewData, setAccrualOverviewData] = useState([]);
  const [accrualBasedActualData, setAccrualBasedActualData] = useState(null);
  const [fromDate, toDate] = billingDateRange;
  const [loading, setLoading] = useState(false);
  const [selectedFinancialProject, setSelectedFinancialProject] = useState(null);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [financialData, setFinancialData] = useState(null);
  const [categoryFinancialData, setCategoryFinancialData] = useState([]);
  const [categoryInputValue, setCategoryInputValue] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [type, setType] = useState("sales");
  const fullMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const monthMap = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December",
  };
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear)
  const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

  const labels = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  const accrualValues = accrualOverviewData.map(item => Number(item.open_accrual));
  const actualValues = accrualOverviewData.map(item => Number(item.closed_actual));
  const totalAccrualValues = accrualOverviewData.map(item => Number(item.total_accrual));

  let filteredLabels = [];
  let filteredAccrual = [];
  let filteredActual = [];
  let filteredTotalAccrual = [];

  if (selectedMonth && accrualBasedActualData) {
    const totalAccrual = accrualBasedActualData[`${type}_total_accrual`] ?? 0;
    const openAccrual = accrualBasedActualData[`${type}_open_accrual`] ?? 0;
    const closedActuals = accrualBasedActualData[`${type}_closed_accrual`] || {};

    const monthKeys = Object.keys(closedActuals);
    filteredLabels = monthKeys.map(m => labels[Number(m.split('-')[1]) - 1]);

    filteredAccrual = [];
    filteredTotalAccrual = [];
    filteredActual = [];

    Object.entries(closedActuals).forEach(([month, value], idx) => {
      if (idx === 0) {
        filteredAccrual.push(openAccrual);
        filteredTotalAccrual.push(totalAccrual);
        filteredActual.push(value);
      } else {
        filteredAccrual.push(null);
        filteredTotalAccrual.push(null);
        filteredActual.push(value);
      }
    });

  } else {
    filteredLabels = labels;
    filteredAccrual = accrualValues;
    filteredActual = actualValues;
    filteredTotalAccrual = totalAccrualValues;
  }

  const data = {
    labels: filteredLabels,
    datasets: [
      {
        label: selectedMonth ? "Total Accrual" : "Open Accrual",
        data: selectedMonth ? filteredTotalAccrual : filteredAccrual,
        backgroundColor: "#FDA48E",
        borderRadius: 6,
        barPercentage: selectedMonth ? 0.4 : 0.7,
        categoryPercentage: selectedMonth ? 0.1 : 0.4,
      },
      {
        label: "Closed Accrual",
        data: filteredActual,
        backgroundColor: "#84B4F5",
        borderRadius: 6,
        barPercentage: selectedMonth ? 0.4 : 0.7,
        categoryPercentage: selectedMonth ? 0.1 : 0.4,
      },
    ],
  };


  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        mode: "index",
        intersect: false,
        external: function (context) {
          const tooltipModel = context.tooltip;

          let tooltipEl = document.getElementById('chartjs-tooltip');
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.style.background = '#fff';
            tooltipEl.style.border = '1px solid #ddd';
            tooltipEl.style.padding = '14px';
            tooltipEl.style.borderRadius = '6px';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.fontWeight = '500';
            tooltipEl.style.transition = '0.2s ease';
            tooltipEl.style.fontFamily = 'Work Sans, sans-serif';
            tooltipEl.style.fontSize = '12px';
            tooltipEl.style.color = '#1d1d1f';
            tooltipEl.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
            document.body.appendChild(tooltipEl);
          }

          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          const dataIndex = tooltipModel.dataPoints[0].dataIndex;
          const totalAccrual = filteredTotalAccrual[dataIndex];
          const openAccrual = filteredAccrual[dataIndex];
          const closedActual = filteredActual[dataIndex];
          const isSelectedMonth = selectedMonth && tooltipModel.dataPoints[0].label === selectedMonth;

          let innerHtml = '';

          const totalLabel = type === 'sales' ? 'Sales Total Accrual' : 'Cost Total Accrual';
          const openLabel = type === 'sales' ? 'Sales Open Accrual' : 'Cost Open Accrual';
          const closedLabel = type === 'sales' ? 'Sales Closed Accrual' : 'Cost Closed Accrual';

          if (totalAccrual !== null && totalAccrual !== undefined) {
            const totalAccrualColor = isSelectedMonth ? '#FDA48E' : '#6929E2';
            innerHtml += `<span style="color:${totalAccrualColor}; font-size:18px;">●</span> ${totalLabel}: ${totalAccrual}<br>`;
          }

          if (!isSelectedMonth && openAccrual !== null && openAccrual !== undefined) {
            innerHtml += `<span style="color:#FDA48E; font-size:18px;">●</span> ${openLabel}: ${openAccrual}<br>`;
          }

          if (closedActual !== null && closedActual !== undefined) {
            innerHtml += `<span style="color:#84B4F5; font-size:18px;">●</span> ${closedLabel}: ${closedActual}<br>`;
          }


          const month = tooltipModel.dataPoints[0].label;
          innerHtml = `<div style="color:#6929E2; font-weight:600; margin-bottom:6px;">${month} ${selectedYear}</div>` + innerHtml;

          tooltipEl.innerHTML = innerHtml;

          const canvasRect = context.chart.canvas.getBoundingClientRect();
          const tooltipWidth = tooltipEl.offsetWidth;
          const tooltipHeight = tooltipEl.offsetHeight;

          let left = canvasRect.left + window.pageXOffset + tooltipModel.caretX - tooltipWidth / 2;
          let top = canvasRect.top + window.pageYOffset + tooltipModel.caretY - tooltipHeight - 10;

          left = Math.max(left, 0);
          top = Math.max(top, 0);

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = left + 'px';
          tooltipEl.style.top = top + 'px';
        }
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { stepSize: 50 },
        grid: {
          drawTicks: false,
          drawBorder: false,
          borderDash: [5, 5],
          color: "#D7DFE4",
          lineWidth: 1,
        },
        border: { dash: [4, 4] },
      },
      x: { grid: { display: false } },
    },
  };

  const containerStyle = {
    width: "100%",
    height: "450px",
    borderRadius: "8px"
  };

  const center = {
    lat: 37.7749,
    lng: -122.4194
  };

  useEffect(() => {
    if (activeTab !== "Operational" || !jobsData) return;

    const options = {
      series: [
        jobsData.draft || 0,
        jobsData.submitted || 0,
        jobsData.partially_invoiced || 0,
        jobsData.completed || 0
      ],
      chart: {
        type: "donut",
        height: 220,
      },
      labels: ["Draft", "Submitted", "Partially Invoiced", "Completed"],
      colors: ["#454CF2", "#7A82F6", "#A5ADF8", "#D3D8FC"],
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 90,
          offsetY: 10,
          dataLabels: { enabled: false },
          donut: { size: "85%", labels: { show: false } },
        },
      },
      legend: { show: false },
      dataLabels: { enabled: false },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val, opts) {
            return val;
          },
        },
        style: {
          fontSize: '12px',
          padding: {
            top: 2,
            right: 5,
            bottom: 1,
            left: 5,
          }
        }
      },
      grid: { padding: { bottom: -100 } },
      states: {
        normal: { filter: { type: 'none', value: 0 } },
        hover: { filter: { type: 'none', value: 0 } },
        active: { filter: { type: 'none', value: 0 } },
      },
    };

    const chart = new ApexCharts(document.querySelector("#jobs-donut"), options);
    chart.render();

    return () => chart.destroy();
  }, [activeTab, jobsData]);

  const [allProjects, setAllProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axiosInstance.get("/loginBasedProjectAutocomplete");
        const projects = res.data?.autosuggestion || [];
        const mapped = projects.map(item => ({ label: item.label, value: item.value }));
        setAllProjects(mapped);
      } catch (error) {
        console.error(error);
      }
    };
    fetchProjects();
  }, []);


  const loadProjectOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback(allProjects);
      return;
    }

    const filtered = allProjects.filter(item =>
      item.label.toUpperCase().includes(inputValue.toUpperCase())
    );
    callback(filtered);
  };

  const [allJobTypes, setAllJobTypes] = useState([]);

  useEffect(() => {
    const fetchJobTypes = async () => {
      try {
        const res = await axiosInstance.get("/jobtype/autosuggestion");
        const options = res.data?.autosuggestion || [];
        const mapped = options.map(item => ({ label: item.label, value: item.value }));
        setAllJobTypes(mapped);
      } catch (error) {
        console.error("Job type suggestion error:", error);
      }
    };
    fetchJobTypes();
  }, []);

  const loadJobTypes = (inputValue, callback) => {
    if (!inputValue) {
      callback(allJobTypes);
      return;
    }
    const filtered = allJobTypes.filter(item =>
      item.label.toUpperCase().includes(inputValue.toUpperCase())
    );
    callback(filtered);
  };
  const [allCategoriesData, setAllCategoriesData] = useState([]);
  const [isCategoriesLoaded, setIsCategoriesLoaded] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axiosInstance.get("/costsolution/category/autosuggestion");
        const options = res.data?.autosuggestion || [];
        const mapped = options.map(item => ({ label: item.label, value: item.value }));
        setAllCategoriesData(mapped);
        setIsCategoriesLoaded(true);
      } catch (error) {
        console.error("Categories suggestion error:", error);
      }
    };
    fetchCategories();
  }, []);
  const loadCategories = (inputValue, callback) => {
    if (!inputValue) {
      callback(allCategoriesData);
      return;
    }
    const filtered = allCategoriesData.filter(item =>
      item.label.toUpperCase().includes(inputValue.toUpperCase())
    );
    callback(filtered);
  };

  const salesinvoiceData = [
    { status: "Draft", count: salesInvoiceData?.draft || 0, color: "#3b3eed", className: "draft-status" },
    { status: "Submitted", count: salesInvoiceData?.submitted || 0, color: "#6a6fed", className: "submitted-status" },
    { status: "Rejected", count: salesInvoiceData?.rejected || 0, color: "#9aa0f5", className: "rejected-status" },
    { status: "Approved", count: salesInvoiceData?.approved || 0, color: "#c2c8f7", className: "sap-status" },
    // { status: "Final Invoice", count: salesInvoiceData?.final_invoice || 0, color: "#e0e4fc", className: "final-status" },
  ];
  const maxCount = Math.max(...salesinvoiceData.map(d => d.count));


  const handleJobsDateChange = (update) => {
    setJobsDateRange(update);
    if (update[0] && update[1]) {
      fetchJobsData(update[0], update[1]);
    }
  };

  const handleSalesDateChange = (update) => {
    setSalesDateRange(update);
    if (update[0] && update[1]) {
      fetchSalesInvoiceData(update[0], update[1]);
    }
  };


  const handleCostDateChange = (update) => {
    setCostDateRange(update);
    if (update[0] && update[1]) {
      fetchCostInvoiceData(update[0], update[1]);
    }
  };

  const fetchJobsData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const projectIds = selectedProjects.map(p => p.value);

      const requestBody = {
        from_date: formatDate(startDate),
        to_date: formatDate(endDate)
      };

      if (projectIds.length > 0) {
        requestBody.project_id = projectIds;
      }

      const response = await axiosInstance.post('/getJobsStatusOverview', requestBody);
      setJobsData(response.data);
    } catch (error) {
      console.error('Error fetching jobs data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSalesInvoiceData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const projectIds = selectedProjects.map(p => p.value);

      const requestBody = {
        from_date: formatDate(startDate),
        to_date: formatDate(endDate)
      };

      if (projectIds.length > 0) {
        requestBody.project_id = projectIds;
      }

      const response = await axiosInstance.post('/getSalesInvStatusOverview', requestBody);
      setSalesInvoiceData(response.data);
    } catch (error) {
      console.error('Error fetching sales invoice data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCostInvoiceData = async (startDate, endDate) => {
    try {
      setLoading(true);
      const projectIds = selectedProjects.map(p => p.value);

      const requestBody = {
        from_date: formatDate(startDate),
        to_date: formatDate(endDate)
      };

      if (projectIds.length > 0) {
        requestBody.project_id = projectIds;
      }

      const response = await axiosInstance.post('/getCostInvStatusOverview', requestBody);
      setCostInvoiceData(response.data);
    } catch (error) {
      console.error('Error fetching cost invoice data:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const projectIds = selectedProjects.map(p => p.value);
        const requestBody = projectIds.length > 0 ? { project_id: projectIds } : {};

        const [contractsRes, projectsRes] = await Promise.all([
          axiosInstance.post('/getContractsOverview', requestBody),
          axiosInstance.post('/getProjectsOverview', requestBody)
        ]);

        setContractsData(contractsRes.data);
        setProjectsData(projectsRes.data);

        if (!jobsStartDate || !jobsEndDate) {
          const jobsRes = await axiosInstance.post('/getJobsStatusOverview', requestBody);
          setJobsData(jobsRes.data);
        }

        if (!salesStartDate || !salesEndDate) {
          const salesRes = await axiosInstance.post('/getSalesInvStatusOverview', requestBody);
          setSalesInvoiceData(salesRes.data);
        }

        if (!costStartDate || !costEndDate) {
          const costRes = await axiosInstance.post('/getCostInvStatusOverview', requestBody);
          setCostInvoiceData(costRes.data);
        }
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [selectedProjects]);

  // Contracts Overview
  useEffect(() => {
    const fetchContractsData = async () => {
      try {
        const projectIds = selectedProjects.map(p => p.value);
        const requestBody = projectIds.length > 0 ? { project_id: projectIds } : {};

        const response = await axiosInstance.post('/getContractsOverview', requestBody);
        setContractsData(response.data);
      } catch (error) {
        console.error('Error fetching contracts data:', error);
      }
    };

    fetchContractsData();
  }, [selectedProjects]);


  // Jobs Overview
  useEffect(() => {
    const fetchJobsData = async (startDate = null, endDate = null) => {
      try {
        setLoading(true);
        const projectIds = selectedProjects.map(p => p.value);

        const requestBody = {};
        if (startDate && endDate) {
          requestBody.from_date = formatDate(startDate);
          requestBody.to_date = formatDate(endDate);
        }
        if (projectIds.length > 0) {
          requestBody.project_id = projectIds;
        }

        const response = await axiosInstance.post('/getJobsStatusOverview', requestBody);
        setJobsData(response.data);
      } catch (error) {
        console.error('Error fetching jobs data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (!jobsStartDate || !jobsEndDate) {
      fetchJobsData();
    }
  }, [selectedProjects]);

  useEffect(() => {
    const fetchSalesInvoiceData = async (startDate = null, endDate = null) => {
      try {
        setLoading(true);
        const projectIds = selectedProjects.map(p => p.value);

        const requestBody = {};
        if (startDate && endDate) {
          requestBody.from_date = formatDate(startDate);
          requestBody.to_date = formatDate(endDate);
        }
        if (projectIds.length > 0) {
          requestBody.project_id = projectIds;
        }

        const response = await axiosInstance.post('/getSalesInvStatusOverview', requestBody);
        setSalesInvoiceData(response.data);
      } catch (error) {
        console.error('Error fetching sales invoice data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (!salesStartDate || !salesEndDate) {
      fetchSalesInvoiceData();
    }
  }, [selectedProjects]);

  // Cost Invoice Overview
  useEffect(() => {
    const fetchCostInvoiceData = async (startDate = null, endDate = null) => {
      try {
        setLoading(true);
        const projectIds = selectedProjects.map(p => p.value);

        const requestBody = {};
        if (startDate && endDate) {
          requestBody.from_date = formatDate(startDate);
          requestBody.to_date = formatDate(endDate);
        }
        if (projectIds.length > 0) {
          requestBody.project_id = projectIds;
        }

        const response = await axiosInstance.post('/getCostInvStatusOverview', requestBody);
        setCostInvoiceData(response.data);
      } catch (error) {
        console.error('Error fetching cost invoice data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (!costStartDate || !costEndDate) {
      fetchCostInvoiceData();
    }
  }, [selectedProjects]);

  // Accrual Overview
  useEffect(() => {
    const fetchAccrualOverviewData = async () => {
      try {
        const projectIds = selectedProjects.map(p => p.value);
        const requestBody = { year: selectedYear, type };
        if (projectIds.length > 0) requestBody.project_id = projectIds;

        const response = await axiosInstance.post('/getAccrualActualOverview', requestBody);
        setAccrualOverviewData(response.data || []);
      } catch (error) {
        console.error(error);
        setAccrualOverviewData([]);
      }
    };
    fetchAccrualOverviewData();
  }, [selectedYear, selectedProjects, type]);

  useEffect(() => {
    const fetchAccrualBasedActualData = async () => {
      if (!selectedMonth) return setAccrualBasedActualData(null);
      try {
        const projectIds = selectedProjects.map(p => p.value);
        const monthNumber = (labels.indexOf(selectedMonth) + 1).toString().padStart(2, '0');
        const monthParam = `${selectedYear}-${monthNumber}`;

        const requestBody = { month: monthParam, year: selectedYear, type };
        if (projectIds.length > 0) requestBody.project_id = projectIds;

        const response = await axiosInstance.post('/getAccrualBasedActual', requestBody);
        setAccrualBasedActualData(response.data);
      } catch (error) {
        console.error(error);
        setAccrualBasedActualData(null);
      }
    };
    fetchAccrualBasedActualData();
  }, [selectedMonth, selectedYear, selectedProjects, type]);


  const getProjectDetails = (projectId) => {
    return projectsData?.projects?.find((p) => p.id === projectId);
  };

  useEffect(() => {
    const fetchFinancialData = async () => {
      if (!selectedFinancialProject || !fromDate || !toDate) {
        setFinancialData(null);
        return;
      }

      try {
        const response = await axiosInstance.post('/getProjectFinancial', {
          from_date: fromDate.toISOString().split('T')[0],
          to_date: toDate.toISOString().split('T')[0],
          project_id: selectedFinancialProject.value
        });
        setFinancialData(response.data);
      } catch (error) {
        console.error('Error fetching financial data:', error);
        setFinancialData(null);
      }
    };

    fetchFinancialData();
  }, [selectedFinancialProject, fromDate, toDate]);


  const pieData = {
    labels: salesinvoiceData.map(item => item.status),
    datasets: [
      {
        data: salesinvoiceData.map(item => item.count),
        backgroundColor: salesinvoiceData.map(item => item.color),
        borderWidth: 1,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context) => ` ${context.raw}`,
        },
      },
    },
  };

  const fetchCategoryFinancialData = async () => {
    if (!selectedCategories || selectedCategories.length === 0) {
      setCategoryFinancialData([]);
      return;
    }

    try {
      setLoading(true);
      const requestBody = {
        category_ids: selectedCategories.map(cat => cat.value)
      };

      if (selectedFinancialProject) {
        requestBody.project_id = selectedFinancialProject.value;
      }

      if (fromDate && toDate) {
        requestBody.from_date = fromDate.toISOString().split('T')[0];
        requestBody.to_date = toDate.toISOString().split('T')[0];
      }

      const response = await axiosInstance.post('/getCategoryFinancial', requestBody);
      setCategoryFinancialData(response.data?.data || []);
    } catch (error) {
      console.error('Error fetching category financial data:', error);
      setCategoryFinancialData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryChange = (selected) => {
    setSelectedCategories(selected || []);
  };

  useEffect(() => {
    fetchCategoryFinancialData();
  }, [selectedCategories, selectedFinancialProject, fromDate, toDate]);

  const handleRemove = (removedItem) => {
    const updated = selectedCategories.filter(
      (cat) => cat.value !== removedItem.value
    );
    setSelectedCategories(updated);
  };

  const fetchJobsWithoutDate = async () => {
    try {
      setLoading(true);

      const projectIds = selectedProjects.map(p => p.value);
      const requestBody = {};

      if (projectIds.length > 0) {
        requestBody.project_id = projectIds;
      }

      const res = await axiosInstance.post('/getJobsStatusOverview', requestBody);
      setJobsData(res.data);
    } finally {
      setLoading(false);
    }
  };

  const fetchSalesWithoutDate = async () => {
    try {
      setLoading(true);

      const projectIds = selectedProjects.map(p => p.value);
      const body = projectIds.length ? { project_id: projectIds } : {};

      const res = await axiosInstance.post('/getSalesInvStatusOverview', body);
      setSalesInvoiceData(res.data);
    } catch (error) {
      console.error("Error fetching sales invoice overview:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCostWithoutDate = async () => {
    try {
      setLoading(true);

      const projectIds = selectedProjects.map(p => p.value);
      const body = projectIds.length ? { project_id: projectIds } : {};

      const res = await axiosInstance.post('/getCostInvStatusOverview', body);
      setCostInvoiceData(res.data);
    } catch (error) {
      console.error("Error fetching cost invoice overview:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DashboardHeader onSearch={null} disableSearch={true} />

      <div className="dashboard-containers">
        <div className="dashboard-containers">
          {projectsData?.login_type === "U" ? (
            // ✅ User login → show default projects (from API)
            <div className="dashboard-overview-multi-projects-card">
              {projectsData?.projects?.map((proj) => (
                <div key={proj.id} className="dashboard-multi-project-card">
                  <div className="multi-projects-card-info">
                    <h3>{proj.project_name}</h3>
                    <p className="multi-projects-location">
                      <img src={location} className="icon-red" alt="location" />
                      <span>{proj.location_name || "N/A"}</span>
                      <span className="multi-projects-area">
                        {proj.area_sqft ? `${proj.area_sqft} Sqft` : "N/A"}
                      </span>
                    </p>
                    <div className="multi-projects-card-meta">
                      <p className="multi-projects-employees">
                        <FaUsers />{" "}
                        {proj.employees_count
                          ? `${proj.employees_count} employees`
                          : "N/A"}
                      </p>
                      <span className="dashboard-stars">
                        {[...Array(5)].map((_, i) => (
                          <FaStar key={i} className={i < rating ? "star filled" : "star empty"} />
                        ))}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            // ✅ Admin / Super Admin login → show only when selectedProjects exist
            <>
              {selectedProjects.length > 0 && (
                selectedProjects.length <= 1 ? (
                  selectedProjects.map((project, index) => {
                    const details = getProjectDetails(project.value);
                    return (
                      <div key={index} className="dashboard-card">
                        <div className="dashboard-left">
                          <div className="dashboard-avatar">VG</div>
                          <div className="dashboard-info">
                            <h2 className="dashboard-title">{project.label}</h2>
                            <div className="dashboard-location">
                              <img src={location} className="icon-red" alt="location" />
                              <span style={{ fontSize: '12px', color: '#9299A7' }}>
                                {details?.location_name || "N/A"}
                              </span>
                              <span className="dashboard-sqft">
                                {details?.area_sqft ? `${details.area_sqft} Sqft` : "N/A"}
                              </span>
                            </div>
                            <div className="dashboard-employees">
                              <FaUsers />
                              <span style={{ fontSize: '12px', color: '#9299A7' }}>
                                {details?.employees_count
                                  ? `${details.employees_count} employees`
                                  : "N/A"}
                              </span>
                              <span className="dashboard-stars">
                                {[...Array(5)].map((_, i) => (
                                  <FaStar key={i} className={i < rating ? "star filled" : "star empty"} />
                                ))}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="dashboard-overview-multi-projects-card">
                    {selectedProjects.map((project, index) => {
                      const details = getProjectDetails(project.value);
                      return (
                        <div key={index} className="dashboard-multi-project-card">
                          <div className="multi-projects-card-info">
                            <h3>{project.label}</h3>
                            <p className="multi-projects-location">
                              <img src={location} className="icon-red" alt="location" />
                              <span>{details?.location_name || "N/A"}</span>
                              <span className="multi-projects-area">
                                {details?.area_sqft ? `${details.area_sqft} Sqft` : "N/A"}
                              </span>
                            </p>
                            <div className="multi-projects-card-meta">
                              <p className="multi-projects-employees">
                                <FaUsers />{" "}
                                {details?.employees_count
                                  ? `${details.employees_count} employees`
                                  : "N/A"}
                              </p>

                              <span className="dashboard-stars">
                                {[...Array(5)].map((_, i) => (
                                  <FaStar key={i} className={i < rating ? "star filled" : "star empty"} />
                                ))}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )
              )}
            </>
          )}
        </div>

        <div className="dashboard-tabs-section">
          <div className="dashboard-tabs-container">
            <div className="dashboard-left-tabs-section">
              <button
                className={`dashboard-tab-button ${activeTab === "Operational" ? "active" : ""}`}
                onClick={() => setActiveTab("Operational")}
              >
                Operational
              </button>

              <AdditionalPermissionWrapper permissionKey="financial_dashboard" moduleId={ModuleId}>
                <button
                  className={`dashboard-tab-button ${activeTab === "financial" ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab("financial");
                    setSelectedProjects([]);
                  }}
                >
                  Financial
                </button>
              </AdditionalPermissionWrapper>
            </div>

            {activeTab === "Operational" && (
              <div className="">
                <AsyncSelect
                  isMulti
                  cacheOptions
                  classNamePrefix="custom-select"
                  closeMenuOnSelect={false}
                  loadOptions={loadProjectOptions}
                  placeholder="Select Project"
                  isClearable
                  defaultOptions={allProjects}
                  value={selectedProjects}
                  onChange={(selected) => setSelectedProjects(selected || [])}
                  openMenuOnClick={true}
                  openMenuOnFocus={true}
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "9999px",
                      minWidth: "230px",
                      width: "auto",
                      borderColor: "transparent",
                      minHeight: "40px",
                      boxShadow: "none",
                      fontSize: "13px",
                      "&:hover": { borderColor: "transparent" },
                    }),
                    container: base => ({ ...base, width: '100%' }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#777",
                      fontSize: "13px",
                    }),
                    option: (base, state) => ({
                      ...base,
                      fontSize: "13px",
                      color: state.isSelected ? "#fff" : "#333",
                      backgroundColor: state.isSelected
                        ? "#4a90e2"
                        : state.isFocused
                          ? "#f0f0f0"
                          : "transparent",
                      cursor: "pointer",
                      height: "auto",
                      // lineHeight: "40px",
                      // padding: "0 10px",
                    }),
                    dropdownIndicator: base => ({ ...base, padding: '8px' }),
                    clearIndicator: base => ({ ...base, padding: '8px' }),
                    menu: base => ({
                      ...base,
                      zIndex: 999,
                      fontSize: '13px',
                      marginTop: '4px',
                      boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      overflowY: "scroll",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: '#F0F4F8',
                      borderRadius: '4px',
                      padding: '2px 6px',
                      margin: '2px'
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: '#19324C',
                      fontSize: '11px',
                      fontWeight: 500,
                      maxWidth: '80px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: '#19324C',
                      ':hover': {
                        backgroundColor: 'transparent',
                        color: '#ff0000'
                      }
                    }),
                    noOptionsMessage: (base) => ({
                      ...base,
                      fontSize: "12px",
                      color: "#999",
                      padding: "6px 10px",
                      textAlign: "left",
                    }),
                  }}
                />
              </div>
            )}

            {activeTab === "financial" && (
              <div className="financial-filters-row" style={{ display: 'flex', gap: '10px' }}>
                <div className="dashboard-right-tabs-section">
                  <AsyncSelect
                    classNamePrefix="custom-select"
                    loadOptions={loadProjectOptions}
                    placeholder="Select Project"
                    isClearable
                    cacheOptions
                    defaultOptions={allProjects}
                    openMenuOnClick={true}
                    openMenuOnFocus={true}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    onChange={setSelectedFinancialProject}
                    value={selectedFinancialProject}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "9999px",
                        minWidth: "180px",
                        width: "auto",
                        borderColor: "transparent",
                        minHeight: "40px",
                        boxShadow: "none",
                        fontSize: "13px",
                        "&:hover": { borderColor: "transparent" },
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      placeholder: (base) => ({
                        ...base,
                        color: "#777",
                        fontSize: "13px",
                      }),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "13px",
                        color: state.isSelected ? "#fff" : "#333",
                        backgroundColor: state.isSelected
                          ? "#4a90e2"
                          : state.isFocused
                            ? "#f0f0f0"
                            : "transparent",
                        cursor: "pointer",
                        height: "auto",
                        // lineHeight: "40px",
                        // padding: "0 10px",
                      }),
                      menu: base => ({
                        ...base,
                        zIndex: 999,
                        fontSize: '13px',
                        marginTop: '4px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                      }), noOptionsMessage: (base) => ({
                        ...base,
                        fontSize: "12px",
                        color: "#999",
                        padding: "6px 10px",
                        textAlign: "left",
                      }),
                    }}
                  />
                </div>

                <div className="dashboard-right-tabs-section">
                  <AsyncSelect
                    isMulti
                    value={[]}
                    classNamePrefix="custom-select"
                    inputValue={categoryInputValue}
                    onInputChange={setCategoryInputValue}
                    onChange={handleCategoryChange}
                    loadOptions={loadCategories}
                    placeholder={categoryInputValue ? "" : "Select Category"}
                    cacheOptions
                    defaultOptions={allCategoriesData}
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    noOptionsMessage={({ inputValue }) =>
                      inputValue ? "No results" : "Type to search categories"
                    }
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isClearable
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "9999px",
                        minWidth: "180px",
                        width: "auto",
                        minHeight: "40px",
                        fontSize: "13px",
                        "&:hover": { borderColor: "transparent" },
                        boxShadow: "none",
                        borderColor: "transparent",
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      menu: (base) => ({ ...base, fontSize: "13px", zIndex: 999 }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "auto",
                        "&::-webkit-scrollbar": { display: "none" },
                      }),
                      multiValue: (base) => ({
                        ...base,
                        display: "none",
                      }),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999
                      }),
                      multiValueRemove: () => ({ display: "none" }),
                    }}
                    components={{
                      DropdownIndicator: null,
                      IndicatorSeparator: null,
                      Option: ({ children, ...props }) => (
                        <components.Option {...props}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              setSelectedCategories((prev) =>
                                prev.find(item => item.value === props.value)
                                  ? prev.filter((item) => item.value !== props.value)
                                  : [...prev, { value: props.value, label: children }]
                              );
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={selectedCategories.some(item => item.value === props.value)}
                              readOnly
                              style={{ marginRight: "8px", cursor: "pointer" }}
                            />
                            {children}
                          </div>
                        </components.Option>
                      ),
                    }}
                  />
                </div>

                <div className="dashboard-right-tabs-section">
                  <DatePicker
                    selectsRange={true}
                    startDate={fromDate}
                    endDate={toDate}
                    onChange={(update) => setBillingDateRange(update)}
                    isClearable={true}
                    placeholderText="Select Billing Date Range"
                    className='billing-date-input'
                  />
                </div>

                <div className="dashboard-right-tabs-section">
                  <AsyncSelect
                    classNamePrefix="custom-select"
                    loadOptions={loadJobTypes}
                    placeholder="Select JobType"
                    isClearable
                    cacheOptions
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    defaultOptions={allJobTypes}
                    noOptionsMessage={() => "No results"}
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "9999px",
                        minWidth: "180px",
                        width: "auto",
                        borderColor: "transparent",
                        minHeight: "40px",
                        boxShadow: "none",
                        fontSize: "13px",
                        "&:hover": { borderColor: "transparent" },
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: "#777",
                        fontSize: "13px",
                      }),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999
                      }),
                      container: base => ({ ...base, width: '100%' }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: "13px",
                        color: state.isSelected ? "#fff" : "#333",
                        backgroundColor: state.isSelected
                          ? "#4a90e2"
                          : state.isFocused
                            ? "#f0f0f0"
                            : "transparent",
                        cursor: "pointer",
                        height: "auto",
                        // lineHeight: "40px",
                        // padding: "0 10px",
                      }),
                      menu: base => ({
                        ...base,
                        zIndex: 999,
                        fontSize: '13px',
                        marginTop: '4px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: "200px",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                      }), noOptionsMessage: (base) => ({
                        ...base,
                        fontSize: "12px",
                        color: "#999",
                        padding: "6px 10px",
                        textAlign: "left",
                      }),
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {activeTab === "Operational" && (
          <div className="operational-tab-content">
            <div className='dashboard-overview-first-card'>
              <div className='dashboard-project-overview-card'>
                <h3>Projects overview</h3>
                <div className="overview-total">
                  <h3>{projectsData?.total || 0}</h3>
                  <p>Total projects</p>
                </div>
                <div className="overview-regions">
                  <div className="region east" style={{ background: '#F3F4F6' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#A59A87'
                      }}></span>
                      EAST
                    </span>
                    <span style={{ color: '#172B4D' }} className="count">{projectsData?.east_zone || 0}</span>
                  </div>
                  <div className="region west" style={{ background: '#FEF3C7' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#F0CA69'
                      }}></span>
                      WEST
                    </span>
                    <span style={{ color: '#172B4D' }} className="count">{projectsData?.west_zone || 0}</span>
                  </div>
                  <div className="region north" style={{ background: '#FEE2E2' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#E97F7F'
                      }}></span>
                      NORTH
                    </span>
                    <span style={{ color: '#172B4D' }} className="count">{projectsData?.north_zone || 0}</span>
                  </div>
                  <div className="region south" style={{ background: '#ECFDF5' }}>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#6EB579'
                      }}></span>
                      SOUTH
                    </span>
                    <span style={{ color: '#172B4D' }} className="count">{projectsData?.south_zone || 0}</span>
                  </div>
                </div>
              </div>

              <div className='dashboard-contract-overview-card'>
                <h3>Contracts overview</h3>

                <div className="contract-stats">
                  <div className="total-count">
                    <p>TOTAL COUNT</p>
                    <h1>{contractsData?.total?.count || 0}</h1>
                    <p className="percentage">
                      <span className="highlight">{contractsData?.total?.change || 0}%</span> more than last month
                    </p>
                  </div>

                  <div className="divider"></div>

                  <div className="contract-box expired">
                    <div>
                      <div className="contract-label">
                        <span className="dot expired-dot"></span>
                        <p>Expired</p>
                      </div>
                      <h2>{contractsData?.expired?.count || 0}</h2>
                      <p className="percentage">
                        <span className="highlight" >{contractsData?.expired?.percentage || 0}%</span> more than last month
                      </p>
                    </div>

                    <div className="contract-shape expired-shape">
                      <LiquidChart
                        value={(contractsData?.expired?.percentage || 0) / 100}
                        color="#FF8989"
                      /></div>
                  </div>

                  <div className="contract-box expiring">
                    <div>
                      <div className="contract-label">
                        <span className="dot expiring-dot"></span>
                        <p>Expiring</p>
                      </div>
                      <h2>{contractsData?.expiring?.count || 0}</h2>
                      <p className="percentage">
                        <span className="highlight">{contractsData?.expiring?.percentage || 0}%</span> more than last month
                      </p>

                    </div>
                    <div className="contract-shape expiring-shape">
                      <LiquidChart
                        value={(contractsData?.expiring?.percentage || 0) / 100}
                        color="#EDB900"
                      /></div>
                  </div>
                </div>

                <div className="contract-info">
                  <span><img src={contract_overview_icon} /></span>
                  <p>Expiring contracts indicate that they are currently nearing their end date.</p>
                </div>
              </div>
            </div>



            <div className='dashboard-overview-second-card'>
              <div className="dashboard-jobs-overview">
                <div className="dashboard-jobs-overview-header">
                  <h2>Jobs overview</h2>
                  <div className="jobs-date-range-wrapper">
                    <DatePicker
                      selectsRange={true}
                      startDate={jobsStartDate}
                      endDate={jobsEndDate}
                      onChange={handleJobsDateChange}
                      customInput={
                        <button className="dashboard-date-range-btn">
                          <img src={daterange} className="calendar-icon" alt="calendar" />
                          {jobsStartDate && jobsEndDate
                            ? `${jobsStartDate.toLocaleDateString()} - ${jobsEndDate.toLocaleDateString()}`
                            : "Date range"}
                        </button>
                      }
                    />
                    {jobsStartDate && jobsEndDate && (
                      <button
                        className="jobs-clear-date-btn"
                        onClick={() => {
                          setJobsDateRange([null, null]);
                          fetchJobsWithoutDate();
                        }}
                      >
                        X
                      </button>
                    )}
                  </div>
                </div>

                <div className="jobs-chart-container">
                  <div
                    id="jobs-donut"
                    className="jobs-invoice-chart"
                    style={{ position: "relative", width: "220px", height: "120px" }}
                  />

                  <div className="chart-center">
                    <span className="total-label">Total jobs</span>
                    <span className="total-jobs">{jobsData?.total || 0}</span>
                  </div>
                </div>

                <div className="jobs-legend">
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color draft-status"></span>
                      Draft
                    </div>
                    <span className="legend-count">{jobsData?.draft || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color submitted-status"></span>
                      Submitted
                    </div>
                    <span className="legend-count">{jobsData?.submitted || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color partially-invoiced-status"></span>
                      Partially Invoiced
                    </div>
                    <span className="legend-count">{jobsData?.partially_invoiced || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color completed-status"></span>
                      Completed
                    </div>
                    <span className="legend-count">{jobsData?.completed || 0}</span>
                  </div>
                </div>
              </div>

              <div className='dashboard-sales-invoice-overview'>
                <div className="dashboard-jobs-overview-header">
                  <h2>{salesStartDate && salesEndDate ? "Sales Invoice" : "Sales Invoice overview"}</h2>
                  <div className="jobs-date-range-wrapper">
                    <DatePicker
                      selectsRange={true}
                      startDate={salesStartDate}
                      endDate={salesEndDate}
                      onChange={handleSalesDateChange}
                      customInput={
                        <button className="dashboard-date-range-btn">
                          <img src={daterange} className="calendar-icon" alt="calendar" />
                          {salesStartDate && salesEndDate
                            ? `${salesStartDate.toLocaleDateString()} - ${salesEndDate.toLocaleDateString()}`
                            : "Date range"}
                        </button>
                      }
                    />
                    {salesStartDate && salesEndDate && (
                      <button
                        className="jobs-clear-date-btn"
                        onClick={() => {
                          setSalesDateRange([null, null]);
                          fetchSalesWithoutDate();
                        }}
                      >
                        X
                      </button>
                    )}
                  </div>
                </div>

                <div className="sales-invoice-content">
                  <div className="invoice-chart" style={{ width: 100, height: 96, flexShrink: 0 }}>
                    <Pie data={pieData} options={pieOptions} width={100} height={96} />
                  </div>

                  <div className="invoice-summary">
                    <div className="summary-item" style={{ marginBottom: '5px' }}>
                      <div className="summary-left">
                        <img className="summary-icon" src={final_invoice} alt="Final" />
                      </div>
                      <div className="summary-right">
                        <div className="summary-label">Total invoice</div>
                        <div className="summary-value">{salesInvoiceData?.total || 0}</div>
                      </div>
                    </div>

                    <hr className="summary-divider" />

                    <div className="summary-item" style={{ marginTop: '5px' }}>
                      <div className="summary-left">
                        <img className="summary-icon" src={total_invoice} alt="Total" />
                      </div>
                      <div className="summary-right">
                        <div className="summary-label">Final invoiced</div>
                        <div className="summary-value final">{salesInvoiceData?.final_invoice || 0}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="jobs-legend">
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color draft-status"></span>
                      Draft
                    </div>
                    <span className="legend-count">{salesInvoiceData?.draft || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color submitted-status"></span>
                      Submitted
                    </div>
                    <span className="legend-count">{salesInvoiceData?.submitted || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color partially-invoiced-status"></span>
                      Rejected
                    </div>
                    <span className="legend-count">{salesInvoiceData?.rejected || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color completed-status"></span>
                      Approved
                    </div>
                    <span className="legend-count">{salesInvoiceData?.approved || 0}</span>

                  </div>
                  <div className="approved-subitems">
                    <div className="subitem">
                      <span className="subitem-label">(Pending Sap Details)</span>
                      <span className="subitem-value">{salesInvoiceData?.pending_sales_document || 0}</span>
                    </div>
                    <div className="subitem">
                      <span className="subitem-label">(Pending Files)</span>
                      <span className="subitem-value">{salesInvoiceData?.pending_sales_files || 0}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className='dashboard-cost-invoice-overview'>
                <div className="dashboard-jobs-overview-header">
                  <h2>{costStartDate && costEndDate ? "Cost Invoice" : "Cost Invoice overview"}</h2>
                  <div className="jobs-date-range-wrapper">
                    <DatePicker
                      selectsRange
                      startDate={costStartDate}
                      endDate={costEndDate}
                      onChange={handleCostDateChange}
                      popperPlacement="bottom-end"
                      customInput={
                        <button className="dashboard-date-range-btn">
                          <img src={daterange} className="calendar-icon" alt="calendar" />
                          {costStartDate && costEndDate
                            ? `${costStartDate.toLocaleDateString()} - ${costEndDate.toLocaleDateString()}`
                            : "Date range"}
                        </button>
                      }
                    />
                    {costStartDate && costEndDate && (
                      <button
                        className="jobs-clear-date-btn"
                        onClick={() => {
                          setCostDateRange([null, null]);
                          fetchCostWithoutDate();
                        }}
                      >
                        X
                      </button>
                    )}
                  </div>
                </div>

                <div className="cost-invoice-content">
                  <div className="invoice-chart" style={{ width: 100, height: 96, flexShrink: 0 }}>
                    <Pie
                      data={{
                        labels: ["Draft", "Submitted", "Rejected", "Approved"],
                        datasets: [{
                          data: [
                            costInvoiceData?.draft || 0,
                            costInvoiceData?.submitted || 0,
                            costInvoiceData?.rejected || 0,
                            costInvoiceData?.approved || 0,
                          ],
                          backgroundColor: ["#3b3eed", "#6a6fed", "#9aa0f5", "#c2c8f7"],
                          borderWidth: 1,
                        }],
                      }}
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: { display: false },
                          tooltip: {
                            callbacks: {
                              label: (context) => ` ${context.raw}`,
                            },
                          },
                        },
                      }}
                      width={100}
                      height={96}
                    />
                  </div>

                  <div className="invoice-summary">
                    <div className="summary-item" style={{ marginBottom: '5px' }}>
                      <div className="summary-left">
                        <img className="summary-icon" src={final_invoice} alt="Final" />
                      </div>
                      <div className="summary-right">
                        <div className="summary-label">Total invoice</div>
                        <div className="summary-value">{costInvoiceData?.total || 0}</div>
                      </div>
                    </div>

                    <hr className="summary-divider" />

                    <div className="summary-item" style={{ marginTop: '5px' }}>
                      <div className="summary-left">
                        <img className="summary-icon" src={total_invoice} alt="Total" />
                      </div>
                      <div className="summary-right">
                        <div className="summary-label">Final invoiced</div>
                        <div className="summary-value final">{costInvoiceData?.final_invoice || 0}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="jobs-legend">
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color draft-status"></span>
                      Draft
                    </div>
                    <span className="legend-count">{costInvoiceData?.draft || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color submitted-status"></span>
                      Submitted
                    </div>
                    <span className="legend-count">{costInvoiceData?.submitted || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color partially-invoiced-status"></span>
                      Rejected
                    </div>
                    <span className="legend-count">{costInvoiceData?.rejected || 0}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-label">
                      <span className="legend-color completed-status"></span>
                      Approved
                    </div>
                    <span className="legend-count">{costInvoiceData?.approved || 0}</span>
                  </div>
                  <div className="approved-subitems">
                    <div className="subitem">
                      <span className="subitem-label">(Pending Sap Details)</span>
                      <span className="subitem-value">{costInvoiceData?.pending_cost_document || 0}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='dashboard-overview-third-card'>
              <div className='accrual-actual-overview'>
                <div className="month-overview-header">
                  <h3> {!selectedMonth ? (
                    <> Accrual and Actual Overview</>
                  ) : (
                    <> Accrual Closure</>
                  )}
                  </h3>
                  <div className="month-filters">
                    <label>
                      Type:
                      <select value={type} onChange={(e) => setType(e.target.value)}>
                        <option value="sales">Sales</option>
                        <option value="cost">Cost</option>
                      </select>
                    </label>

                    <label>
                      Month:
                      <select
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                      >
                        <option value="">Select Month</option>
                        {labels.map((m, idx) => (
                          <option key={m} value={m}>{fullMonthNames[idx]}</option>
                        ))}
                      </select>
                    </label>
                    <label>
                      Year:
                      <select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(Number(e.target.value))}
                      >
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                </div>

                <div className="accrual-actual-wrapper">
                  <div className="accrual-actual-legend-group">
                    {!selectedMonth ? (
                      <>
                        <div className="accrual-actual-legend-item">
                          <span className="accrual-actual-legend-box accrual"></span>
                          <span>
                            {type === "sales" ? "Sales Open Accrual" : "Cost Open Accrual"}
                          </span>
                        </div>
                        <div className="accrual-actual-legend-item">
                          <span className="accrual-actual-legend-box actual"></span>
                          <span>
                            {type === "sales" ? "Sales Closed Accrual" : "Cost Closed Accrual"}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="accrual-actual-legend-item">
                          <span className="accrual-actual-legend-box accrual"></span>
                          <span>
                            {type === "sales" ? "Sales Total Accrual" : "Cost Total Accrual"}
                          </span>
                        </div>
                        <div className="accrual-actual-legend-item">
                          <span className="accrual-actual-legend-box actual"></span>
                          <span>
                            {type === "sales" ? "Sales Closed Accrual" : "Cost Closed Accrual"}
                          </span>
                        </div>
                      </>
                    )}
                  </div>

                  {selectedMonth && (
                    <div className="accrual-actual-created-item">
                      <span>
                        Accruals Created in the Month:
                        <span className="accrual-month"> {monthMap[selectedMonth] || selectedMonth}</span> -
                        <strong>
                          <span className="accrual-month">
                            {type === "sales"
                              ? accrualBasedActualData?.sales_total_accrual ?? 0
                              : accrualBasedActualData?.cost_total_accrual ?? 0}
                          </span>
                        </strong>
                      </span>
                    </div>
                  )}
                </div>


                <div className="chart-card">
                  <Bar data={data} options={options} />
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "financial" && (
          <div className="financial-tab-content">
            {selectedCategories.length > 0 && (
              <div className="financial_categories_cards">
                <p className="financial_categories_text">Selected Category Cards:</p>
                <div className="financial_categories_card_list">
                  {selectedCategories.map((category) => (
                    <div key={category.value} className="financial_categories_card_item">
                      <span>{category.label}</span>
                      <button className="financial_categories_card_remove" onClick={() => handleRemove(category)}>×</button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="financial-overview-pl-card">
              <div className="pl-header-row">
                <h4>P & L Percentage</h4>
                <div className="pl-profit-card">
                  <div className="pl-profit-row">
                    {financialData ? (
                      financialData.status === "Profit" ? (
                        <p className="profit">Profit: {financialData.project.profit_loss_percent}%</p>
                      ) : (
                        <p className="loss">Loss: {financialData.project.profit_loss_percent}%</p>
                      )
                    ) : (
                      <p className="profit">Profit: 0%</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="financial-inner">

                {/* Revenue Section */}
                <div className="financial-box accrual">
                  <p className="title">Sales</p>
                  <p className="value">₹{financialData ? financialData.project.total_sales_actual_value.toLocaleString() : '0'}</p>
                </div>

                {/* Cost Section */}
                <div className="financial-box actual">
                  <p className="title">Cost</p>
                  <p className="value">₹{financialData ? financialData.project.total_cost_actual_value.toLocaleString() : '0'}</p>
                </div>
              </div>
            </div>

            <div className="financial-overview-row">
              {categoryFinancialData.map((category) => (
                <div key={category.category_id} className="financial-overview-card">
                  <h4>{category.category_name}</h4>
                  <div className="financial-inner">
                    <div className="financial-box accrual">
                      <p className="title">Sales</p>
                      <p className="value">₹{category.total_sales?.toLocaleString() || '0'}</p>
                    </div>
                    <div className="financial-box actual">
                      <p className="title">Cost</p>
                      <p className="value">₹{category.total_cost?.toLocaleString() || '0'}</p>
                    </div>
                  </div>
                </div>
              ))
              }
            </div>
            <div className="financial-map-overview">
              <h4 className="map-title">Map View</h4>
              <div className="financial-map-content">
                {/* <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
                  <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={12}>
                    <Marker position={center} />
                  </GoogleMap>
                </LoadScript> */}
              </div>
            </div>
          </div>

        )}
      </div>
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
};

export default Dashboard;
